// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0838a0be","963":"0cf9be80"}[chunkId] + ".chunk.js";
};